import { render } from "./ThankyouPage.vue?vue&type=template&id=0b29855c"
import script from "./ThankyouPage.vue?vue&type=script&lang=js"
export * from "./ThankyouPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__